import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=3a8593c0&"
import script from "./ArticleItem.vue?vue&type=script&lang=js&"
export * from "./ArticleItem.vue?vue&type=script&lang=js&"
import style0 from "./ArticleItem.vue?vue&type=style&index=0&id=3a8593c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports